import { FormattedMessage } from "react-intl";

import styles from "@components/account/Account.module.css";
import Toggle from "@components/buttons/Toggle";
import BodyCopy from "@components/typography/BodyCopy";
import useMutationWithValidation from "@hooks/useMutationWithValidation";
import useMyClient from "@hooks/useMyClient";
import {
  AgreementKindEnum,
  ClientAgreementToggleDocument,
  ClientAgreementToggleMutation,
  ClientAgreementToggleMutationVariables,
  GetClientWithAccountQuery
} from "@typing/Generated";

type Props = {
  client: GetClientWithAccountQuery["client"];
};

const SecurityMarketing = ({ client }: Props) => {
  const myClient = useMyClient();

  const agreements = client.agreements;
  const marketingAgreements = agreements.filter(
    agreement => agreement.kind === AgreementKindEnum.MARKETING_AGREEMENT && !agreement.revoked
  );
  const consultReminderAgreements = agreements.filter(
    agreement => agreement.kind === AgreementKindEnum.CONSULT_REMINDERS && !agreement.revoked
  );

  const wantsMarketingEmails = marketingAgreements && marketingAgreements.length > 0;
  const wantsConsultReminders = consultReminderAgreements && consultReminderAgreements.length > 0;

  const [clientAgreementToggle] = useMutationWithValidation<
    ClientAgreementToggleMutation,
    ClientAgreementToggleMutationVariables
  >(ClientAgreementToggleDocument, "marketing");

  const handleMarketingEmailsChange = (checked: boolean) => {
    clientAgreementToggle({ enabled: checked, kind: AgreementKindEnum.MARKETING_AGREEMENT });
  };

  const handleConsultRemindersChange = (checked: boolean) => {
    clientAgreementToggle({ enabled: checked, kind: AgreementKindEnum.CONSULT_REMINDERS });
  };

  return (
    <>
      <div className={`${styles.securityOptionRow} flex align-center justify-between`}>
        <BodyCopy>
          <FormattedMessage id="pages.client.account.marketingEmailsLabel" />
        </BodyCopy>
        <Toggle
          checked={wantsMarketingEmails}
          disabled={!myClient}
          name="marketingEmails"
          setValue={handleMarketingEmailsChange}
        />
      </div>
      <div className={`${styles.securityOptionRow} flex align-center justify-between ion-margin-bottom`}>
        <BodyCopy>
          <FormattedMessage id="pages.client.account.consultReminderEmailsLabel" />
        </BodyCopy>
        <Toggle
          checked={wantsConsultReminders}
          disabled={!myClient}
          name="consultReminders"
          setValue={handleConsultRemindersChange}
        />
      </div>
    </>
  );
};

export default SecurityMarketing;
